import "./App.css";
import Navbar from "./components/navbar/Navbar";
import Sidebar from "./components/sidebar/Sidebar";
import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "./pages/Home/Home";
import SetupDoubtSession from "./pages/SetupDoubtSession/SetupDoubtSession";
import GemstoneConfiguration from "./pages/GemstoneConfiguration/GemstoneConfiguration";
import BulkNotification from "./pages/BulkNotification/BulkNotification";
import MagazinesConfiguration from "./pages/MagazinesConfiguration/MagazinesConfiguration";
import Consultation from "./pages/Consultation/Consultation";
import Session from "./pages/SessionInfo/Session";
import CouponCodeConfiguration from "./pages/CouponCodeConfiguration/CouponCodeConfiguration";
import CoursesConfiguration from "./pages/CoursesConfiguration/CoursesConfiguration";
import CourseUpload from "./pages/CourseUpload/CourseUpload";
import BannerUpload from "./pages/BannerUpload/BannerUpload";
import PopUp from "./pages/PopUp/PopUp";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login/Login";
import { useEffect, useRef } from "react";
import Blog from "./pages/Blog/Blog";
import PoojaList from "./pages/PoojaList/PoojaList";
import BannerUploadpPooja from "./pages/BannerUploadPooja/BannerUploadpPooja";
import IconUploadPooja from "./pages/IconUploadPooja/IconUploadPooja";
import BanneruploadConsultation from "./pages/BannerUploadConsultation/BanneruploadConsultation";
import IconUploadConsultation from "./pages/IconUploadConsultation/IconUploadConsultation";
import GetTodaysPooja from "./pages/GetTodaysPooja/GetTodaysPooja";
import DateChangeRequest from "./pages/DateChangeRequest/DateChangeRequest";
import Report from "./pages/Report/Report";
import SessionPooja from "./pages/SessionPooja/SessionPooja";
import Analytics from "./pages/Analytics/Analytics";
import ConsultationDateChange from "./pages/ConsultationDateChange/ConsultationDateChange";
import Transaction from "./pages/Transaction/Transaction";
import PoojaCalendar from "./pages/PoojaCalender/PoojaCalendar";
import ConsultationCalendar from "./pages/ConsultationCalendar/ConsultationCalendar";
import WebBlog from "./components/WebBlog/WebBlog";
import AllAstrologers from "./components/AllAstrologers/AllAstrologers";
import Astrologer from "./components/AstrologersComponents/Astrologer/Astrologer";
import Chat from "./components/AstrologersComponents/AstrologerChat/Chat";
import WebsiteBanner from "./components/WebsiteBanner/WebsiteBanner";
import Call from "./components/AstrologersComponents/AstrologerCall/Call";
import DailyHoroscope from "./components/DailyHoroscope/DailyHoroscope";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { API_END_POINT_Socket } from "./constant";
import AgoraCall from "./components/AstrologersComponents/AstrologerCall/AgoraCall";
import AstrologerAnalytics from "./components/AstrologersComponents/AstrologerAnalytics/AstrologerAnalytics";
import GemstoneUpload from "./components/GemstoneUpload/GemstoneUpload";
import AstroAna from "./components/AstrologersComponents/AstrologerAnalytics/AstroAna";

function App() {
  const stompClient = useRef(null);
  const navigate = useNavigate()
  const TOKEN = localStorage.getItem("accessToken");
  const astro_id = localStorage.getItem("astro_id");

  const connect = () => {
    try {
      const socket = new SockJS(
        `${API_END_POINT_Socket}${encodeURIComponent(TOKEN)}`
      );

      stompClient.current = new Client({
        webSocketFactory: () => socket,
        debug: () => { },
        onConnect: () => {
          console.log("STOMP connected");
        },
        onStompError: (frame) => {
          console.error("STOMP error:", frame.headers["message"], frame.body);
          alert("STOMP connection error – see console");
        },
        onWebSocketError: (error) => {
          console.error("WebSocket error:", error);
          alert("WebSocket error – see console");
        }
      });

      stompClient.current.activate();
    } catch (e) {
      alert(e.message);
    }
  };

  useEffect(() => {
    connect();
  }, [astro_id])

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const isAstrologer = localStorage.getItem("isAstrologer") === "true";
    // connect();
    if (!token) {
      navigate("/login");
    } else if (
      token &&
      (window.location.pathname === "/login" ||
        window.location.pathname === "/") &&
      isAstrologer
    ) {
      navigate(`/astrologer/${localStorage.getItem("astrologerId")}`);
    } else if (
      token &&
      (window.location.pathname === "/login" ||
        window.location.pathname === "/")
    ) {
      navigate("/home");
    }
  }, [navigate]);

  return (
    <>
      {localStorage.getItem("accessToken") && (
        <>
          <Navbar />
          <Sidebar />
        </>
      )}

      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {localStorage.getItem("accessToken") && (
          <>
            <Route path="/home" element={<Home />} />
            <Route path="/setupdoubtsession" element={<SetupDoubtSession />} />
            <Route
              path="/magazinesConfiguration"
              element={<MagazinesConfiguration />}
            />
            <Route
              path="/gemstoneconfiguration"
              element={<GemstoneConfiguration />}
            />
            <Route path="/gemstoneImage/:gemstoneId" element={<GemstoneUpload />} />
            <Route path="/all-astrologers" element={<AllAstrologers />} />
            <Route path="/astrologersAnalytics" element={<AstrologerAnalytics />} />
            <Route path="/astrologer/:id" element={<Astrologer />} />
            <Route path="/astrologer/chat/:id" element={<Chat />} />
            <Route path="/astrologer/call/:id" element={<Call />} />
            <Route path="/astrologer/analytics/:id" element={<AstroAna />} />
            <Route path="/agoraCall" element={<AgoraCall />} />
            <Route
              path="/couponCodeConfiguration"
              element={<CouponCodeConfiguration />}
            />
            <Route path="/dailyHoroscope" element={<DailyHoroscope />} />
            <Route path="/bulkNotifucations" element={<BulkNotification />} />
            <Route path="/bannerUpload" element={<BannerUpload />} />
            <Route
              path="/coursesCodeConfiguration"
              element={<CoursesConfiguration />}
            />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/websiteBanner" element={<WebsiteBanner />} />
            <Route path="/session" element={<Session />} />
            <Route path="/sessionPooja" element={<SessionPooja />} />
            <Route path="/courseupload" element={<CourseUpload />} />

            <Route path="/popup" element={<PopUp />} />

            <Route path="/blog" element={<Blog />} />

            <Route path="/onlinepooja" element={<PoojaList />} />

            <Route path="/banneruploadpooja" element={<BannerUploadpPooja />} />

            <Route path="/iconuploadpooja" element={<IconUploadPooja />} />

            <Route
              path="/banneruploadconsultation"
              element={<BanneruploadConsultation />}
            />
            <Route
              path="/iconuploadconsultation"
              element={<IconUploadConsultation />}
            />
            <Route path="/gettodayspooja" element={<GetTodaysPooja />} />
            <Route path="/datechangerequest" element={<DateChangeRequest />} />
            <Route
              path="/consultationdatechange"
              element={<ConsultationDateChange />}
            />

            <Route path="/report" element={<Report />} />

            <Route path="/analytics" element={<Analytics />} />

            <Route path="/transaction" element={<Transaction />} />

            <Route path="/poojaCalendar" element={<PoojaCalendar />} />

            <Route
              path="/ConsultationCalendar"
              element={<ConsultationCalendar />}
            />

            <Route path="/Webblog" element={<WebBlog />} />
          </>
        )}
      </Routes>

      {/* toaster container */}
      <ToastContainer />
    </>
  );
}

export default App;
